<template>
  <div style="margin-top: 50px">
    <div class="faq-hero">
      <div class="faq-hero-sec">
        <div style="font-weight: 700; font-size: 30px" v-html="$t('faqNormalHeroTitle')">
        </div>
        <div style="font-weight: 400; font-size: 13px">
          {{ $t('faqHeroDescription') }}
        </div>
      </div>
    </div>
    <div style="background-color: #F5F6F9;">
      <v-row class="container" style="margin: 0 !important">
        <v-col>
          <div style="gap: 10px; display: flex; overflow-x: auto;">
            <v-chip v-for="(item, idx) in program" :key="idx" :class="[
              selectedProgram == idx ? 'sub-program-active' : '',
              'sub-program',
            ]" @click="changeProgram(idx, item.key)">{{ $t(`faqProgram.${item.name}`) }}</v-chip>
          </div>
          <h4 class="text-center my-5" v-if="program[selectedProgram].sub_program">Sub menu</h4>
          <div v-if="program[selectedProgram].sub_program" style="gap: 10px; display: flex; overflow-x: auto;">
            <v-chip v-for="(item, idx) in program[selectedProgram].data" :key="idx" :class="[
              selectedSubProgram == idx ? 'sub-program-active' : '',
              'sub-program',
            ]" @click="changeSubProgram(idx, item.key)">{{
              $t(`faqProgram.${program[selectedProgram].name}Sub.${item.name}`) }}</v-chip>
          </div>
          <div v-if="!program[selectedProgram].sub_program" style="margin-top: 30px;">
            <AccordeonFaq v-for="(item, index) in dataFaq" :key="index" :title="item.title"
              :description="item.description" :active="item.active" @toggle="toggleAccordion(index)" />
          </div>
          <div v-if="program[selectedProgram].sub_program" style="margin-top: 30px">
            <AccordeonFaq v-for="(item, index) in dataFaq" :key="index" :title="item.title"
              :description="item.description" :active="item.active" @toggle="toggleAccordion(index)" />
          </div>
          <empty-data v-if="!dataFaq.length" :message="$t('faqEmptyDataMessage')" />
        </v-col>
      </v-row>
    </div>
    <v-card elevation="0" class="call-center-container">
      <v-row style="padding: 20px 8px">
        <v-col cols="12">
          <div class="call-center-title">
            {{ $t('faqFinalCTAHeading') }}
          </div>
          <div class="call-center-desc">
            {{ $t('faqFinalCTACaption') }}
          </div>
        </v-col>
        <v-col cols="12" class="call-center-button" @click="sendToWa">
          <v-btn class="btn" elevation="0"> {{ $t('faqContactUsButton') }} </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import EmptyData from "../../others/EmptyData.vue";
import AccordeonFaq from "@/components/AccordeonFaq.vue";

export default {
  components: {
    EmptyData,
    AccordeonFaq
  },
  data() {
    return {
      selectedProgram: 0,
      selectedSubProgram: 0,
      categorySelect: '',
      dataFaq: [],
      program: [
        {
          name: "general",
          key: "HOME",
          sub_program: false,
        },
        {
          name: "bootcamp",
          key: "BOOTCAMP",
          sub_program: false,
        },
        // {
        //   name: "prakerja",
        //   key: "PRAKERJA",
        //   sub_program: false,
        // },
        {
          name: "corporateService",
          key: "CORPORATE",
          sub_program: true,
          data: [
            { name: "general", key: "CORPORATE" },
            { name: "corpCollaboration", key: "COLLABORATION" },
            { name: "accelerationProgram", key: "ACCELERATION" },
            { name: "corpTraining", key: "TRAINING" },
            { name: "talentAsAService", key: "TALENT_SERVICE" },
            { name: "technologyService", key: "SERVICES" },
          ],
        },
        // {
        //   name: "kampusMerdeka",
        //   key: "KAMPUS_MERDEKA",
        //   sub_program: true,
        //   data: [
        //     { name: "general", key: "KAMPUS_MERDEKA" },
        //     { name: "magangBersertifikat", key: "MAGANG" },
        //   ],
        // },
      ],
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getFaqByName(this.categorySelect);
    },
  },
  methods: {
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `Contact Us - WhatsApp - FAQ Mobile Page - Program: ${this.program[this.selectedProgram].name}`,
        value: 1,
      });
      window.open("https://wa.me/6281234567890", "_blank");
    },
    async getFaqByName(name) {
      try {
        const resp = await this.$http.get(
          `/v1/faq?category=${name}`
        );
        this.dataFaq = resp.data.data.faq || [];
        this.dataFaq = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    toggleAccordion(index) {
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Toggle FAQ - ${this.dataFaq[index].title} - FAQ Mobile Page - Program: ${this.program[this.selectedProgram].name}`,
        value: 1,
      });
      this.dataFaq[index].active = !this.dataFaq[index].active;
    },
    changeProgram(idx, key) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Select Program - ${this.program[idx].name} - FAQ Mobile Page`,
        value: 1,
      });
      this.selectedProgram = idx;
      this.selectedSubProgram = 0;
      this.categorySelect = key;
      this.getFaqByName(key);
    },
    changeSubProgram(idx, key) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Select Sub-Program - ${this.program[this.selectedProgram].name} - ${this.program[this.selectedProgram].data[idx].name} - FAQ Mobile Page`,
        value: 1,
      });
      this.selectedSubProgram = idx;
      this.categorySelect = key;
      this.getFaqByName(key);
    },
  },
  mounted() {
    this.getFaqByName("HOME");
    this.$gtag.pageview(this.$route);
  }
};
</script>

<style src="./faq.css" scoped></style>